import React from 'react';
import SectionMessage from '@atlaskit/section-message';
import { useUiModificationsErrors } from '../use-ui-modifications-errors';

export function UiModificationsSectionsMessages() {
    const [uiModificationError] = useUiModificationsErrors();

    if (uiModificationError !== null) {
        return <SectionMessage appearance="error">{uiModificationError.message}</SectionMessage>;
    }
    return null;
}
